export class Modules {
  public static readonly PaymentRequests_Code: number = 2;
}
